import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import GrandTotalCard from './GrandTotalCard';
import MadrivoCard from './MadrivoCard';
import DiabloCard from './DiabloCard';
import BrightReachCard from './BrightReachCard';
import BannerEdgeCard from './BannerEdgeCard';
import Shift44Card from './Shift44Card';
import LeadGroupCard from './LeadGroupCard';

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Get user data from localStorage
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="dashboard-container">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div className="main-content">
        <Topbar 
          user={user} 
          onLogout={handleLogout} 
          onToggleSidebar={toggleSidebar}
        />
        
        <div className="content-wrapper">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h1 className="h3 mb-0 text-gray-800">Revenue Dashboard</h1>
              <p className="text-muted mb-0">Welcome back, {user?.username}!</p>
            </div>
            <div className="text-muted d-none d-md-block">
              <small>Data automatically updated daily at 4 AM Pacific Time</small>
            </div>
          </div>

          {/* Grand Total Card */}
          <GrandTotalCard />

          <div className="row">
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <MadrivoCard />
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <DiabloCard />
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <BrightReachCard />
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <BannerEdgeCard />
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <Shift44Card />
            </div>
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <LeadGroupCard />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 